module.exports = __webpack_public_path__ + "static/media/Ex1-S2VideoCover.6d954fcf.PNG";